<template>
  <div>
    <div
      class="columns is-gapless is-marginless"
      v-if="membre">
      <div
        class="column is-narrow is-flex is-padding-small tooltip is-tooltip-right"
        :class="isCheck ? 'has-background-success' : bgFalse"
        :data-tooltip="isCheck ? 'Fiche complète' : 'Fiche incomplète'">
        <span
          class="icon has-text-white is-self-centered"
          :class="isCheck ? 'has-text-white' : textFalse"><i
            :class="isCheck ? 'fa-check-circle' : 'fa-exclamation-circle'"
            class="fas"></i></span>
      </div>
      <div class="column columns is-padding-small is-gapless is-multiline">
        <div class="column is-6 is-4-widescreen is-4-fullhd is-padding-xxsmall">
          <r-label
            v-if="isMembrePromoteur"
            :label="'RÉSERVANT / PROMOTEUR'"
            :is-required="false"></r-label>
          <r-label
            v-else-if="isCoAcquereur"
            :label="'RÉSERVATAIRE / CO-Acquéreur'"
            :is-required="false"></r-label>
          <r-label
            v-else
            :label="'RÉSERVATAIRE / Acquéreur'"
            :is-required="false"></r-label>

          <div class="title is-5 has-text-weight-medium">
            <div
              v-if="isMembrePromoteur"
              class="title is-5 has-text-weight-medium">
              <div class="is-uppercase">
                {{ membre.company_name || 'NC' }}
              </div>
              <div
                class="is-uppercase"
                v-if="membre.rep_first_name && membre.rep_last_name">
                {{ membre.rep_last_name }} <span style="is-uppercase">{{ membre.rep_first_name }}</span>
              </div>
            </div>
            <div
              v-else
              class="title is-5 has-text-weight-medium">
              <div
                class="is-uppercase"
                v-if="'nature' in membre && membre.nature && membre.nature === 'corporation'">
                {{ membre.corporation_name }}
              </div>
              <div
                class="is-uppercase"
                v-if="membre.first_name && membre.last_name">
                {{ membre.title }}. {{ membre.last_name }} <span class="is-uppercase">{{ membre.first_name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6 is-4-widescreen is-4-fullhd is-padding-xxsmall">
          <r-label
            :label="'Adresse'"
            :is-required="false"></r-label>
          <div
            class="title is-5 has-text-weight-medium"
            v-if="membre && membre.address">
            <span
              v-if="membre.address.line1"
              class="is-break-word">{{ membre.address.line1 }}</span>
            <br v-if="membre.address.line1">
            <span v-if="membre.address.zip_code || membre.address.city">{{ membre.address.zip_code }} {{ membre.address.city }}</span>
            <br v-if="membre.address.zip_code || membre.address.city">
            <span v-if="membre.address.country">{{ membre.address.country }}</span>
            <span
              v-if="!membre.address.line1 && !membre.address.zip_code &&
                !membre.address.country && !membre.address.city">
              NC
            </span>
          </div>
          <div
            class="title is-5 has-text-weight-medium"
            v-else-if="membre && membre.rep_address">
            <span v-if="membre.rep_address.line1">{{ membre.rep_address.line1 }}</span>
            <br v-if="membre.rep_address.line1">
            <span v-if="membre.rep_address.zip_code || membre.rep_address.city">{{ membre.rep_address.zip_code }} {{ membre.rep_address.city }}</span>
            <br v-if="membre.rep_address.zip_code || membre.rep_address.city">
            <span v-if="membre.rep_address.country">{{ membre.rep_address.country }}</span>
            <span
              v-if="!membre.rep_address.line1 && !membre.rep_address.zip_code &&
                !membre.rep_address.country && !membre.rep_address.city">
              NC
            </span>
          </div>
        </div>
        <div class="column is-12 is-4-widescreen is-4-fullhd columns is-gapless is-multiline">
          <div class="column is-6 is-12-widescreen is-12-fullhd is-padding-xxsmall">
            <r-label
              :label="'Téléphone'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium">
              <phone-number
                v-if="'phone' in membre && membre.phone"
                :phone="membre.phone"></phone-number>
              <phone-number
                v-else-if="'rep_phone' in membre && membre.rep_phone"
                :phone="membre.rep_phone"></phone-number>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div class="column is-6 is-12-widescreen is-12-fullhd is-padding-xxsmall">
            <r-label
              :label="'Mail'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium">
              <span>{{ membre.email || membre.rep_email || 'NC' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isMembrePromoteur && canEdit"
        class="actionsOnRow actionsOnRow--vertical">
        <div class="is-minH100">
          <button
            @click="openModalPromoteurInfo()"
            class="tooltip is-tooltip-left"
            data-tooltip="Modifier informations promoteur">
            <span class="icon"><i class="fal fa-file-edit"></i></span>
          </button>
        </div>
      </div>
      <div
        v-else
        class="actionsOnRow actionsOnRow--vertical">
        <div
          class=""
          v-if="canEdit">
          <template v-if="fromResa">
            <button
              @click="$emit('updateContact', membre, index)"
              class="tooltip is-tooltip-left"
              data-tooltip="Modifier la fiche contact">
              <span class="icon"><i class="fal fa-file-edit"></i></span>
            </button>
          </template>
          <template v-else>
            <router-link
              tag="button"
              :to="{name: 'ContactEdit', params: {id: membre.pk, advProgram: advProgram}, query: {check: true}}"
              class="tooltip is-tooltip-left"
              data-tooltip="Modifier la fiche contact">
              <span class="icon"><i class="fal fa-file-edit"></i></span>
            </router-link>
          </template>
        </div>
        <div class="actionsOnRo">
          <template>
            <button
              @click="openNewContactQuickview({}, null, null, null, replaceBuyer=true, index)"
              class="tooltip is-tooltip-left"
              data-tooltip="Changer acquéreur">
              <span class="icon"><i class="fal fa-user-friends"></i></span>
            </button>
          </template>
        </div>
        <div
          v-if="isCoAcquereur && canEdit"
          class="">
          <button
            @click="deleteCobuyer(membre)"
            class="tooltip is-tooltip-left is-tooltip-danger"
            data-tooltip="Supprimer le co-acquéreur">
            <span class="icon"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import { Quickview } from '@/mixins'

export default {
  name: 'MembreAdv',
  mixins: [Quickview],
  props: {
    index: Number,
    membre: Object,
    isMembrePromoteur: Boolean,
    isCoAcquereur: Boolean,
    modalPromoteur: Boolean,
    isGrey: {
      type: Boolean,
      default: false
    },
    fromResa: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean
    },
    forPreResa: {
      type: Boolean,
      default: false
    },
    advProgram: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(['currentUser']),
    /**
       * is check
       * @returns {boolean}
       */
    isCheck () {
      if (this.isMembrePromoteur) {
        return !isNil(this.membre.rep_last_name) &&
            !isNil(this.membre.company_name) &&
            !isNil(this.membre.rep_first_name) &&
            !isEmpty(this.membre.rep_address) &&
            !isNil(this.membre.rep_phone) &&
            !isNil(this.membre.rep_email)
      } else {
        return this.membre.is_complete
      }
    },
    /**
       * background class
       * @returns {string}
       */
    bgFalse () {
      if (this.isGrey) {
        return 'has-background-white--darken1'
      } else {
        return 'has-background-danger'
      }
    },
    /**
       * text class
       * @returns {string}
       */
    textFalse () {
      if (this.isGrey) {
        return 'has-text-danger'
      } else {
        return 'has-text-white'
      }
    }
  },
  methods: {
    /**
       * open modal promoteur info
       */
    openModalPromoteurInfo () {
      this.$emit('openModalPromoteurInfo')
    },
    /**
       * emit delete co buyer
       */
    deleteCobuyer (membre) {
      this.$emit('deleteCobuyer', membre)
    }
  }
}
</script>

<style scoped>
.info-profil {
  display: flex;
  flex-flow: row nowrap;
  gap: 5px;
  width: 100%
}

@media (min-width: 1200px) and (max-width: 1410px) {
  .info-profil {
    flex-wrap: wrap;
  }
}
</style>
